export function maskPhoneNumber(phoneNumber) {
  return phoneNumber
    ? phoneNumber.replace(/^(\+\d{1,3})\d{6}/, '$1******')
    : '';
}
